/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var chatLink = document.querySelectorAll('.live-chat-link');
  var chatBox = document.querySelector('.olark-launch-button');
  chatLink.forEach((links) => {
    links.addEventListener('click', function (event) {
      document.querySelector('.olark-launch-button').click();
    });
  });

  var listShowMore = document.querySelectorAll('[data-list-show-more]');
  listShowMore.forEach((show) => {
    show.addEventListener('click', function (e) {
      if(e.target.parentElement.classList.contains('hidden-class')){
        e.target.parentElement.classList.remove('hidden-class');
        e.target.innerHTML = 'More Options';
      }
      else{
        e.target.parentElement.classList.add('hidden-class');
        e.target.innerHTML = 'Less Options';
      }
      e.target.parentElement.previousElementSibling.querySelectorAll('[data-link-hidden]').forEach((link, index) => {
        if(e.target.parentElement.classList.contains('hidden-class')){
          link.classList.remove('hidden');
        }
        else{
          link.classList.add('hidden');
        }
      });
    });
  });
  
  /*$(".live-chat-link").on('click', function(){console.log('dsadsad');
    $(".olark-launch-button").trigger('click');
  });*/
  /*
  var prevThumbBtn = document.querySelector('.scroll-btn-prev');
  if(typeof prevThumbBtn !== 'undefined' && prevThumbBtn !== null){
    prevThumbBtn.addEventListener('click', (e) => {
      divElement = document.querySelector(".product__thumb.is-active");
      elemRect = divElement.getBoundingClientRect();
      elemHeight = elemRect.height;

      var scrolledSteps = document.querySelector("#scrollSteps").value;
      if(scrolledSteps != ''){
        var scrollVal = parseInt(scrolledSteps) + elemHeight;
      }
      else{
        var scrollVal = elemHeight;
      }
      document.querySelector("#scrollSteps").value = scrollVal;
      scrollThumb(scrollVal);
    });
  }

  var nextThumbBtn = document.querySelector('.scroll-btn-next');
  if(typeof nextThumbBtn !== 'undefined' && nextThumbBtn !== null){
    nextThumbBtn.addEventListener('click', (e) => {
      divElement = document.querySelector(".product__thumb");
      elemRect = divElement.getBoundingClientRect();
      elemHeight = elemRect.height;

      var scrolledSteps = document.querySelector("#scrollSteps").value;
      if(scrolledSteps != ''){
        var scrollVal = parseInt(scrolledSteps) - elemHeight;
      }
      else{
        var scrollVal = -(elemHeight);
      }
      document.querySelector("#scrollSteps").value = scrollVal;
      scrollThumb(scrollVal);
    });
  }

  function scrollThumb(scroll){
    var thumbs = document.querySelector('[data-thumbs-slider]');

    thumbs.scrollTo({
      top: scroll,
      left: 0,
      behavior: 'smooth',
    });
  }*/
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

$(document).ready(function () {
  $(window).on("scroll", function () {
    // Show & Hide Text On-Scroll
    if ($(window).scrollTop() > 200) {
       $('.sidebutton').show();
    } else {
    $('.sidebutton').hide();
    }
  });
});

$('.sidebutton').click(function() {
  //alert("456");
   $('.sidebuttontop').attr('aria-expanded', 'false');
//  $(this).attr('aria-expanded', 'true');
 // $('.sidebuttontop').data('min','1000');
     // ^-- missing #
}); 
$('.sidebuttontop').click(function() {
  //alert("456");
   $('.sidebutton').attr('aria-expanded', 'true');
//  $(this).attr('aria-expanded', 'true');
 // $('.sidebuttontop').data('min','1000');
     // ^-- missing #
}); 

/* $('#amount').data('min','1000');
$(document).ready(function () {
   
    $(window).scroll(function(){
     //  alert("123");
      $('.sidebutton').show();
    });
})*/